import { p as jsxRuntimeExports } from "./doenetml-NmXDuMHr.js";
function NonInlineMediaWrapper({
  id,
  displayMode,
  suppressTopMargin,
  layoutStyles,
  media,
  description,
  containerRef,
  containerAttrs
}) {
  const { outerStyle, innerStyle, mediaContainerStyle, mediaColumnStyle } = layoutStyles;
  const containerStyle = suppressTopMargin ? { ...outerStyle, marginTop: 0 } : outerStyle;
  const isInline = displayMode === "inline";
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "div",
    {
      ...containerAttrs,
      id: `${id}-container`,
      ref: containerRef,
      style: containerStyle,
      children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { style: innerStyle, children: [
        isInline ? media : /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: mediaContainerStyle, children: media }),
        isInline || !description ? description : /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: mediaContainerStyle, children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: mediaColumnStyle, children: description }) })
      ] })
    }
  );
}
export {
  NonInlineMediaWrapper as N
};
